import { Component } from '@angular/core';

type WhyusTabId = 'candidates' | 'employers';

interface WhyusItem {
  icon: string;
  iconImg?: string;
  titleKey: string;
  textKey: string;
}

interface WhyusTab {
  id: WhyusTabId;
  iconImg: string;
  tabTitleKey: string;
  tabTextKey: string;
  badgeNumberKey: string;
  badgeTitleKey: string;
  titleLine1Key: string;
  titleStrongKey: string;
  titleLine2Key: string;
  descriptionKey: string;
  primaryButtonKey: string;
  secondaryButtonKey: string;
  primaryRoute: string;
  secondaryRoute: string;
  visualTitleKey: string;
  visualTextKey: string;
  features: WhyusItem[];
  steps: WhyusItem[];
  stats: WhyusItem[];
}


@Component({
  selector: 'app-whyus',
  templateUrl: './whyus.component.html',
  styleUrl: './whyus.component.scss'
})
export class WhyusComponent {
  activeTab: WhyusTabId = 'candidates';

readonly tabs: WhyusTab[] = [
  {
    id: 'candidates',
    iconImg: '/assets/as/14.webp',
    tabTitleKey: 'atw.whyUs.candidates.tabTitle',
    tabTextKey: 'atw.whyUs.candidates.tabText',
    badgeNumberKey: 'atw.whyUs.candidates.badgeNumber',
    badgeTitleKey: 'atw.whyUs.candidates.badgeTitle',
    titleLine1Key: 'atw.whyUs.candidates.titleLine1',
    titleStrongKey: 'atw.whyUs.candidates.titleStrong',
    titleLine2Key: 'atw.whyUs.candidates.titleLine2',
    descriptionKey: 'atw.whyUs.candidates.description',
    primaryButtonKey: 'atw.whyUs.candidates.primaryButton',
    secondaryButtonKey: 'atw.whyUs.candidates.secondaryButton',
    primaryRoute: '/jobs',
    secondaryRoute: '/smartapply',
    visualTitleKey: 'atw.whyUs.candidates.visualTitle',
    visualTextKey: 'atw.whyUs.candidates.visualText',
    features: [
      {
        icon: '',
        iconImg: '/assets/as/17.webp',
        titleKey: 'atw.whyUs.candidates.feature1Title',
        textKey: 'atw.whyUs.candidates.feature1Text'
      },
      {
        icon: '',
        iconImg: '/assets/as/30.webp',
        titleKey: 'atw.whyUs.candidates.feature2Title',
        textKey: 'atw.whyUs.candidates.feature2Text'
      },
      {
        icon: '',
        iconImg: '/assets/as/13.webp',
        titleKey: 'atw.whyUs.candidates.feature3Title',
        textKey: 'atw.whyUs.candidates.feature3Text'
      }
    ],
    steps: [
      {
        icon: '01',
        titleKey: 'atw.whyUs.candidates.step1',
        textKey: 'atw.whyUs.candidates.step1Text'
      },
      {
        icon: '02',
        titleKey: 'atw.whyUs.candidates.step2',
        textKey: 'atw.whyUs.candidates.step2Text'
      },
      {
        icon: '03',
        titleKey: 'atw.whyUs.candidates.step3',
        textKey: 'atw.whyUs.candidates.step3Text'
      }
    ],
    stats: [
      {
        icon: 'FIT',
        titleKey: 'atw.whyUs.candidates.stat1Title',
        textKey: 'atw.whyUs.candidates.stat1Text'
      },
      {
        icon: 'CV',
        titleKey: 'atw.whyUs.candidates.stat2Title',
        textKey: 'atw.whyUs.candidates.stat2Text'
      }
    ]
  },
  {
    id: 'employers',
    iconImg: '/assets/as/9.webp',
    tabTitleKey: 'atw.whyUs.employers.tabTitle',
    tabTextKey: 'atw.whyUs.employers.tabText',
    badgeNumberKey: 'atw.whyUs.employers.badgeNumber',
    badgeTitleKey: 'atw.whyUs.employers.badgeTitle',
    titleLine1Key: 'atw.whyUs.employers.titleLine1',
    titleStrongKey: 'atw.whyUs.employers.titleStrong',
    titleLine2Key: 'atw.whyUs.employers.titleLine2',
    descriptionKey: 'atw.whyUs.employers.description',
    primaryButtonKey: 'atw.whyUs.employers.primaryButton',
    secondaryButtonKey: 'atw.whyUs.employers.secondaryButton',
    primaryRoute: '/iamhiring',
    secondaryRoute: '/create-job',
    visualTitleKey: 'atw.whyUs.employers.visualTitle',
    visualTextKey: 'atw.whyUs.employers.visualText',
    features: [
      {
        icon: '',
        iconImg: '/assets/as/8.png',
        titleKey: 'atw.whyUs.employers.feature1Title',
        textKey: 'atw.whyUs.employers.feature1Text'
      },
      {
        icon: '',
        iconImg: '/assets/as/15.webp',
        titleKey: 'atw.whyUs.employers.feature2Title',
        textKey: 'atw.whyUs.employers.feature2Text'
      },
      {
        icon: '',
        iconImg: '/assets/as/26.webp',
        titleKey: 'atw.whyUs.employers.feature3Title',
        textKey: 'atw.whyUs.employers.feature3Text'
      }
    ],
    steps: [
      {
        icon: '01',
        titleKey: 'atw.whyUs.employers.step1',
        textKey: 'atw.whyUs.employers.step1Text'
      },
      {
        icon: '02',
        titleKey: 'atw.whyUs.employers.step2',
        textKey: 'atw.whyUs.employers.step2Text'
      },
      {
        icon: '03',
        titleKey: 'atw.whyUs.employers.step3',
        textKey: 'atw.whyUs.employers.step3Text'
      }
    ],
    stats: [
      {
        icon: 'HR',
        titleKey: 'atw.whyUs.employers.stat1Title',
        textKey: 'atw.whyUs.employers.stat1Text'
      },
      {
        icon: '24h',
        titleKey: 'atw.whyUs.employers.stat2Title',
        textKey: 'atw.whyUs.employers.stat2Text'
      }
    ]
  }
];

  get activeContent(): WhyusTab {
    return this.tabs.find(tab => tab.id === this.activeTab) || this.tabs[0];
  }

  setActiveTab(tab: WhyusTabId): void {
    this.activeTab = tab;
  }

  trackByTitle(index: number, item: WhyusItem): string {
    return item.titleKey;
  }

  trackByTab(index: number, tab: WhyusTab): string {
    return tab.id;
  }
}